import { combineReducers } from 'redux'

import companies from './companies/reducer'
import users from './users/reducer'

export default combineReducers({
  companies,
  users,
})
